<template>
  <div class="modal-content">
      <div class="modal-header">
          <h4 class="modal-title" id="itemDetailTitle">แจ้งเตือน</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="container-fluid">
          <div class="row">
              <div class="col-12" style="margin-top:1rem;">
                  <span>ยืนยันการยกเลิก</span><span style="color:red;"> *</span>
              </div>
              <div class="col-12" style="margin-top:1rem;">
                <textarea
                maxlength="500"
                class="form-control"
                v-model="remark"
                rows="3"
              ></textarea>
              </div>
              <div class="col-12" style="margin-top:0.5rem; margin-bottom:0.5rem;" v-if="isEmpty">
                <span style="color:red;">* กรุณากรอกสาเหตุการยกเลิก</span>
              </div>
          </div>
      </div>
      <div class="modal-footer">
          <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
        >
          ปิด
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="confirmCancel()"
        >ยืนยัน</button>
      </div>
  </div>
  </template>

  <script>
  import Swal from 'sweetalert2'
  import apiMarim from '../services/service_undefined_v2'
  export default {
    // name: 'stockOutInfoCancel',
    props: ['item'],
    data () {
      return {
        transfer_id: '',
        remark: '',
        isEmpty: false
      }
    },
    methods: {
      setTransferId () {
        this.transfer_id = this.$store.state.transfer_id
        // console.log(this.transfer_id)
      },
      openDetailCancel () {
        // $('#itemStockOutInfoCancel').modal('show')

      },
      confirmCancel () {
        if (this.remark === '') {
          this.isEmpty = true
        } else {
          this.isEmpty = false
          apiMarim.cancelTransferStock({
            remark: this.remark,
            transfer_id: this.transfer_id
          }, result => {
            if (result.data.status) {
              $('#itemStockOutInfoCancel').modal('hide')
              this.$store.state.transfer_detail.status = 'Cancel'
              this.$store.state.transfer_detail.transfer_status = 'ยกเลิก'
              this.$store.state.transfer_detail.remark = this.remark
              this.$store.state.transfer_detail.is_cancel_branch = 1
              Swal.fire({
                icon: 'success',
                title: 'ยกเลิกการโอนย้ายสต๊อกสำเร็จ',
                showConfirmButton: false,
                timer: 2000
              })
            }
          }, errors => {})
        }
      }
    },
    mounted () {
      $('#itemStockOutInfoCancel').on(
        'show.bs.modal',
        function () {
          this.remark = ''
          this.setTransferId()
        }.bind(this)
      )
    }
  }
  </script>

  <style scoped>
  .form-control:-moz-read-only {
    /* For Firefox */
    background-color: #fff;
  }

  .form-control:read-only {
    background-color: #fff;
  }

  #Tdtail {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  #Tdtail td, #Tdtail th {
    border: 1px solid #ddd;
    padding: 5px;
  }

  #Tdtail tr:nth-child(even){background-color: #f2f2f2;}

  #Tdtail tr:hover {background-color: #ddd;}

  #Tdtail th {
    padding-top: 8px;
    padding-bottom: 8px;
    text-align: center;
    background-color: #007bff;
    color: white;
  }
  </style>



// WEBPACK FOOTER //
// src/components/stock_cancel.vue